<template>
<div>
    <div id="box">
    <label>{{ $t("message")["app.dashboard.analysis.timeLabel"] }} :&nbsp;&nbsp;</label>
    <a-date-picker @change="ChangeDataDate"></a-date-picker>
    <!--//english version-->
    <a-radio-group id="device_type_option" v-model:value="device_type" @change="ChangeDeviceType">
      <a-radio :value="1">4G</a-radio>
      <a-radio :value="2">BLE</a-radio>
    </a-radio-group>
    <a-button @click="showModel" v-if="device_type==1" class="primaryBtn" id="btn_group">{{ $t("message")["DeviceList.group.mesage"] }}</a-button>
    </div>
    
    <a-modal v-model="isModalVisible" :title="$t('message')['DeviceList.group.mesage']" @ok="handleOk" @cancel="handleCancel">
        <a-input id="msg_input" v-model="somemessage" type="textarea"></a-input>
    </a-modal>
    <a-spin size="large" :spinning="loading" />
    <div class="main">
        <a-table class="table" :columns="columns" :data-source="data_list" rowKey="Deviceid"
        :pagination="paginationConfig" >
        </a-table>
    </div>
</div>
</template>

<script>
const moment = require('moment');
import request from "../../utils/request";
import domain from "../../domain";
import {getClientId} from '../../utils/auth'

export default {
    data() {
        return {
            clientid: 0,
            isActive: false,
            isModalVisible: false,
            somemessage: '',
            currentPosition: -1,
            columns: [
                {
                    title: this.$t("message")['DeviceList.deviceid'],
                    dataIndex: 'Deviceid',
                },
                {
                    title: this.$t("message")['DeviceList.battery'],
                    dataIndex: 'Battery',
                },
                {
                    title: this.$t("message")['DeviceList.signal'],
                    dataIndex: 'Rssi',
                },
                {
                    title: this.$t("message")['DeviceList.step'],
                    dataIndex: 'Steps',
                },
                {
                    title: this.$t("message")['DeviceList.distance'],
                    dataIndex: 'Distance',
                },
                {
                    title: this.$t("message")['DeviceList.calorie'],
                    dataIndex: 'Calorie',
                },
                {
                    title: this.$t("message")['DeviceList.action'],
                    dataIndex: 'Action',
                    customRender: (text, record, index) => {
                        // Customize the content of the custom column here
                        return (
                        <div>
                            <a-icon type="eye" class="view_icon" />
                            <a href="#" onClick={() => this.itemClick(text, record, index)}>{ this.$t("message")["DeviceList.viewdata"] }</a>
                        </div>
                        );
                    },
                }
            ],
            paginationConfig: {
                pageSize: 20,
            },
            data_list: [],
            device_list: [],
            data_date: '',
            device_type: 1,
            loading: false
        }
    },
    methods: {
        // eslint-disable-next-line
        itemClick(text, record, index) {
            sessionStorage.setItem("deviceid",record["Deviceid"]);
            sessionStorage.setItem("device_type",this.device_type);
            if(this.device_type == 2){
                sessionStorage.setItem("uid",record["Uid"].toString());
            }
            this.$router.push({name:"device_summary",params:{
                data_date: this.data_date,
                model: record["Model"],
                battery: record["Battery"],
                step: record["Steps"]
            }})
        },

        // eslint-disable-next-line
        LoadActiveDeviceListOfDate(clientid, device_type, data_date_str) {
            let that = this
            let url_req = domain.URLS.DeviceList_4G_Url
            if(device_type == 2){
                url_req = domain.URLS.DeviceList_BLE_Url
            }
            console.log(url_req,clientid,data_date_str);
            request({
                //调用接口
                method: "GET",
                url: url_req,
                emulateJSON: true,
                emulateHttp: true,
                params: {
                    clientid: clientid,
                    record_date: data_date_str
                }
            }).then(
                function (response) {
                    //接口返回数据
                    let list = response.data.Data
                    that.data_list=list
                    for(let i=0;i<that.data_list.length;i++){
                        that.device_list.push(that.data_list[i]["Deviceid"])
                    }
                },
                function (error) {
                    console.log(error.data)
                }
            )
        }, 
        ChangeDataDate(val){
            let date_str = val.format('YYYY-MM-DD');
            this.data_date = date_str;
            this.LoadActiveDeviceListOfDate(this.clientid,this.device_type,this.data_date);
        },
        ChangeDeviceType(){
            this.LoadActiveDeviceListOfDate(this.clientid,this.device_type,this.data_date);
        },
        showModel(){
            if(this.loading){
                return;
            }
            this.isModalVisible = true;
        },
        handleOk(){
            this.loading = true;
            let url_req = domain.URLS.Group_Message_url;
            let that = this;
            let postParams = {"title":this.$t("message")["DeviceSetting.Notification.Title"],
                "desc":this.somemessage,
                "device_id_list":this.device_list
            };
            request({
                //调用接口
                method: "POST",
                url: url_req,
                emulateJSON: true,
                emulateHttp: true,
                data: postParams
            }).then(
                function (response) {
                    //接口返回数据
                    that.loading = false
                    console.log('group send msg: ',response.data);
                },
                function (error) {
                    console.log(error.data)
                    that.loading = false
                }
            );
            this.isModalVisible = false;
        },
        handleCancel(){
            this.isModalVisible = false;
        }
    },
    mounted() {
        this.clientid = getClientId();
        let today = new Date();
        let todayStr = moment(today).format('YYYY-MM-DD');
        this.data_date = todayStr;
        this.LoadActiveDeviceListOfDate(this.clientid,this.device_type,this.data_date);
    }
}
</script>

<style scoped>
.main {
    background: #f1f1f1;
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    min-width: 600px;
}

.table {
    width: 100%;
    height: 80vh;
    background: #ffffff;
    margin-top: 20px;
    overflow-y: scroll;
}

.info-section {
    width: 100%;
    height: 50px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    align-items: center;
}

.info-title {
    font-size: 14px;
    width: 100px;
    text-align: left;
    color: #191a18;
    font-weight: bold;
}

.info-title :first-child {
    margin-left: 20px;
}

.user-data {
    font-size: 14px;
    width: 100px;
    text-align: left;
    color: #292e25;
}

.device_id {
    width: 120px;
}

.user-data :first-child {
    margin-left: 20px;
}

.bg_selected {
    background: #2284FF;
    color: #000;
}

.zebra {
    background: #cde6c7;
    color: #000;
}

#under_line {
    width: 100%;
    height: 1px;
    background: #f1f1f1;
}

#device_type_option {
    margin-left: 40px;
}

#btn_group {
    margin-left: 40px;
}

.primaryBtn {
  background-color: #2284FF;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

#box {
  display: flex;
  align-items: center;
}

.view_icon {
    margin-right: 8px;
}
</style>

